document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('recently-viewed')) {
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.fetchAttempts = 0;
        window.initLazyScript(this, this.init.bind(this), 500);
      }

      async init() {
        try {
          const response = await fetch(`${this.dataset.url}&q=${this.getSearchQuery()}`);
          if (!response.ok) throw new Error(response.status);

          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          const el = tmpl.content.querySelector('recently-viewed');
          if (el && el.hasChildNodes()) {
            this.innerHTML = el.innerHTML;
            this.sortByViewOrder();
          }

          window.initLazyImages();
        } catch (error) {
          this.fetchAttempts += 1;

          if (this.fetchAttempts === 3) {
            console.log(error);
          } else {
            this.init();
          }
        }
      }

      // Search returns products by relevance, so put the most recently viewed one first.
      sortByViewOrder() {
        const list = this.querySelector('ul.grid');
        if (!list) return;

        const items = this.getItems();
        [...list.children]
          .sort((a, b) => items.indexOf(Number(a.dataset.productId)) - items.indexOf(Number(b.dataset.productId)))
          .forEach((li) => list.appendChild(li));
      }

      getItems() {
        return JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
      }

      getSearchQuery() {
        const items = this.getItems();

        if (this.dataset.exclude && items.includes(Number(this.dataset.exclude))) {
          items.splice(items.indexOf(Number(this.dataset.exclude)), 1);
        }

        return items.map((item) => `id:${item}`).slice(0, this.dataset.limit).join(' OR ');
      }
    }

    customElements.define('recently-viewed', RecentlyViewed);
  }
});
